/**
 * @file
 * Parallax JS.
*/
(function ($, Drupal, drupalSettings) {

  'use strict';

  /**
   * Listen for scroll and update content relative to background.
   */
  Drupal.behaviors.kinaxisParallax = {
    attach: function(context, settings) {
      drupalSettings.kinaxis = drupalSettings.kinaxis || {};
      drupalSettings.kinaxis.parallaxThreshold = 800; // Controls how soon to start modifying background-position.
      drupalSettings.kinaxis.parrallaxModifier = -0.05; // Controls much to translate the image and in which direction to move.

      // Prevent grey bar on scroll that's most a problem on mobile where the element gets very tall.
      var parallaxHeightAdjust = function() {
        if (window.matchMedia('(max-width: 768px)').matches) {
          $('.parallax-bg-img').each(function() {
            $(this).css('background-size', 'auto ' + ($(this).outerHeight() + drupalSettings.kinaxis.parallaxThreshold / 4) + 'px');
          });
        } else {
          $('.parallax-bg-img').css('background-size', '');
        }
      }

      parallaxHeightAdjust();

      $(window).on('scroll', function() {
        var distance = $(document).scrollTop();
        $('.parallax-bg-img').each(function() {
          var pos = $(this).offset();
          if (distance > (pos.top - drupalSettings.kinaxis.parallaxThreshold)) {
            var offset = distance - pos.top + drupalSettings.kinaxis.parallaxThreshold;
            $(this).css('background-position-y', (offset * drupalSettings.kinaxis.parrallaxModifier) + 'px');
          }
        });
        $('.parallax-text').each(function() {
          var pos = $(this).offset();
          if (distance > (pos.top - drupalSettings.kinaxis.parallaxThreshold)) {
            var offset = distance - pos.top + drupalSettings.kinaxis.parallaxThreshold;
            // Adjust the offset so that the text starts higher up, giving it more room to glide down.
            offset = offset - 350;
            $(this).css('transform', 'translateY(' + (offset * drupalSettings.kinaxis.parrallaxModifier * -1) + 'px)');
          }
        });
      });

      $(window).on('resize', function() {
        parallaxHeightAdjust();
      });
    }
  }

})(jQuery, Drupal, drupalSettings);